import { faGear, faWrench } from '@fortawesome/free-solid-svg-icons';
import { roleConfig } from './roleConfig';

/**
 * 導航配置 - 管理所有菜單項目和對應的路由
 * requiredRole: 需要的最低角色 (1=外包, 2=員工, 3=經理, 4=管理者, 5=協理, 6=維護者)，不設置表示無需權限
 */
export const navigationConfig = [
    {
        label: '首頁',
        path: '/Home',
        componentName: 'Home',
        icon: 'fa-tachometer-alt',
        showInMenu: true,
        isCollapsible: false,
    },
    {
        label: '司機派送',
        path: '/',
        external: true,
        icon: 'fa-car',
        showInMenu: true,
        isCollapsible: false,
    },
    {
        heading: '介面',
        showInMenu: true,
        isCollapsible: false,
    },
    {
        label: '排程',
        icon: 'fa-columns',
        showInMenu: true,
        isCollapsible: true,
        // requiredRole: 2,
        items: [
            { label: '訂單列表', path: '/OrderInfo', componentName: 'OrderInfo', requiredRole: roleConfig['財務'] },
            { label: '排程表', path: '/Schedule', componentName: 'Schedule', requiredRole: roleConfig['財務'] },
            { label: '司機', path: '/DeliverInfo', componentName: 'DeliverInfo', requiredRole: roleConfig['員工'] },
            { label: '指派紀錄', path: '/DeliveryRecord', componentName: 'DeliveryRecord', requiredRole: roleConfig['維護者'] },
            { label: '派車單', path: '/DeliverOrder', componentName: 'StaffOrderInfo', requiredRole: roleConfig['員工'] },
        ],
    },
    {
        label: '設定',
        icon: faGear,
        showInMenu: true,
        isCollapsible: true,
        // requiredRole: 3,
        items: [
            { label: '訂單', path: '/SetOrderRule', componentName: 'OrderRule', requiredRole: roleConfig['管理者'] },
            { label: '區域', path: '/DeliveryArea', componentName: 'DeliveryArea', requiredRole: roleConfig['管理者'] },
            { label: '車輛', path: '/VehicleManagement', componentName: 'VehicleManagement', requiredRole: roleConfig['員工'] },
        ],
    },
    {
        label: '工具',
        icon: faWrench,
        showInMenu: true,
        isCollapsible: true,
        // requiredRole: 3,
        items: [
            { label: '訂單簽署表', path: '/ReceiptForm', componentName: 'ReceiptForm', requiredRole: roleConfig['管理者'] },
            { label: '系統日誌', path: '/LogViewer', componentName: 'LogViewer', requiredRole: roleConfig['維護者'] },
            { label: '借車申請審核', path: '/TruckLoanApproval', componentName: 'TruckLoanApprovalPage', requiredRole: roleConfig['財務'] },
        ],
    },
];

/**
 * 從 navigationConfig 獲取菜單數據
 * 用於 Menu 中的渲染
 */
export const getMenuItems = () => {
    return navigationConfig.filter((item) => item.showInMenu);
};
